import styled from "styled-components";
import { breakpoints } from "../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 80px 0px 0px 0px;
  border-top: 1px solid var(--gray);
  background-color: var(--white);

  // Info Container
  .infoNavsContainer {
    width: 100%;
    max-width: 1270px;
    padding: 40px 0px 0px 0px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }

  // Seguro Bici Logo
  .infoContainer img {
    object-fit: cover;
  }

  .infoContainer a img {
    object-fit: cover;
    max-width: 200px;
    transition: 0.2s all;
  }

  .infoContainer a:hover > img {
    transform: scale(0.9);
  }

  // Seguro Bici Info
  .infoTextContainer {
    margin: 30px 0px 0px 0px;
  }

  .infoTextContainer p {
    margin: 3px 0px 0px 0px;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: var(--black);
  }

  // Navs Container
  .navsContainer {
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }

  // Nav Column
  .navColumn {
    max-width: 195px;
  }

  // Nav Title
  .navColumn p {
    margin: 0px 0px 15px 0px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 0.938em;
    letter-spacing: -0.015em;
    color: var(--black);
  }

  // Nav li
  .navColumn nav li {
    list-style-type: none;
  }

  // Nav li buttons
  .navColumn nav li a {
    text-decoration: none;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 22px;
    color: var(--black);
    transition: 0.2s all;
    cursor: pointer;
  }

  // Nav li buttons hover
  .navColumn nav li a:hover {
    color: var(--orange);
  }

  // Social Media and Data Fiscal Container
  .socialMediaDataFiscalContainer {
    width: 100%;
    max-width: 1270px;
    padding: 35px 0px 50px 0px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  // Social Media Container
  .socialMediaContainer,
  .socialMediaContainerMobile {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  // Socil Media Container Mobile
  .socialMediaContainerMobile {
    display: none;
  }

  // Social Media Container Buttons
  .socialMediaContainer a,
  .socialMediaContainerMobile a {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    background-color: var(--orange);
    cursor: pointer;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    color: var(--white);
    font-size: 1em;
    transition: 0.2s;
  }

  // Social Media Buttons Hover
  .socialMediaContainer a:hover {
    background-color: var(--white);
    color: var(--orange);
    transform: scale(1.4);
  }

  // Data Fiscal Container
  .dataFiscalContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
  }

  // Data Fiscal Logos
  .dataFiscalContainer img {
    display: block;
    margin-left: 35px;
  }

  // Hr border bottom
  hr {
    margin: 0px 0px 0px 0px;
    border-top: 1px solid var(--gray);
    border-bottom: 0px;
  }

  // Copyright
  #copyrightText {
    width: 100%;
    margin: 0px 0px 0px 0px;
    max-width: 1270px;
    padding: 20px 0px 20px 0px;
    margin: 0 auto;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    color: var(--black);
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    // Info Container
    .infoNavsContainer {
      max-width: 1100px;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 1100px;
    }

    // Copyright
    #copyrightText {
      max-width: 1100px;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Info Container
    .infoNavsContainer {
      max-width: 1000px;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 1000px;
    }

    // Copyright
    #copyrightText {
      max-width: 1000px;
    }
  }

  //1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Info Container
    .infoNavsContainer {
      max-width: 850px;
    }

    .infoContainer {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;
      margin: 0px 0px 30px 0px;
    }

    .infoContainer img {
      width: auto;
    }

    .infoTextContainer {
      width: auto;
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: center;
      align-items: center;
      margin: 25px 0px 5px 0px;
      text-align: right;
    }

    .infoTextContainer p {
      margin: 0px 15px 0px 0px;
    }

    // Navs Container
    .navsContainer {
      max-width: 100%;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 850px;
    }

    // Data Fiscal Logos
    .dataFiscalContainer img {
      margin-left: 25px;
    }

    #logoGyS {
      max-width: 179px;
    }

    #logoPDP {
      max-width: 72px;
    }

    #logoSSN {
      max-width: 179px;
    }

    #logoEncrypt {
      max-width: 106px;
    }

    #logoFiscal {
      max-width: 33px;
    }

    // Copyright
    #copyrightText {
      max-width: 850px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    // Info Container
    .infoNavsContainer {
      max-width: 700px;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 700px;
    }

    // Data Fiscal Container
    .dataFiscalContainer {
      justify-content: space-around;
      flex-wrap: wrap;
      flex-direction: row;
      width: 100%;
      margin: 30px 0px 0px 0px;
    }

    // Data Fiscal Logos
    .dataFiscalContainer img {
      margin-left: 0px;
    }

    // Copyright
    #copyrightText {
      max-width: 700px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Info Container
    .infoContainer {
      margin: 0px 0px 0px 0px;
    }

    .infoNavsContainer {
      max-width: 600px;
    }

    .infoTextContainer {
      width: 100%;
      justify-content: flex-start;
      margin: 25px 0px 0px 0px;
    }

    .socialMediaContainerMobile {
      display: flex;
      margin: 30px 0px 10px 0px;
    }

    // Navs Container
    .navsContainer {
      width: 70%;
      max-width: none;
    }

    // Nav Column
    .navColumn {
      width: 50%;
      max-width: none;
      margin: 30px 0px 0px 0px;
    }

    .socialMediaContainer {
      display: none;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 600px;
    }

    // Data Fiscal
    .dataFiscalContainer {
      display: flex;
      flex-wrap: wrap;
    }

    // Data Fiscal Logos
    .dataFiscalContainer img {
      margin: 0px 35px 0px 0px;
    }

    // Copyright
    #copyrightText {
      width: 100%;
      text-align: center;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    // Info Container
    .infoNavsContainer {
      max-width: 540px;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 540px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Info Container
    .infoNavsContainer {
      max-width: 400px;
      justify-content: center;
    }

    .infoContainer {
      justify-content: center;
    }

    .infoTextContainer {
      justify-content: center;
    }

    .infoTextContainer p {
      width: 100%;
      text-align: center;
      line-height: 28px;
      margin: 0px 0px 0px 0px;
    }

    .socialMediaContainerMobile a {
      margin: 0px 7px 0px 7px;
    }

    // Navs Container
    .navsContainer {
      width: 100%;
      justify-content: center;
    }

    // Nav Column
    .navColumn {
      width: 100%;
      text-align: center;
      max-width: none;
      justify-content: center;
      margin: 30px 0px 0px 0px;
    }

    // Social Media and Data Fiscal Container
    .socialMediaDataFiscalContainer {
      max-width: 400px;
    }

    // Data Fiscal Container
    .dataFiscalContainer {
      max-width: 400px;
      display: block;
      margin: 0 auto;
    }

    // Data Fiscal Logos
    .dataFiscalContainer img {
      margin: 0 auto;
      padding: 25px 0px 0px 0px;
    }

    #logoFiscal {
      padding: 40px 0px 0px 0px;
    }

    // Copyright
    #copyrightText {
      max-width: 400px;
      line-height: 22px;
    }
  }
`;

export default Container;
